(function($){
        
	// Add Loaded Class
	$('.ptx-madlib').addClass('ptx-madlib--loaded');
  
})(jQuery);